import React, { Component } from "react";

import lucka from '../../images/team/Lucka.JPG';
import tawy from '../../images/team/Tawy.JPG';
import vasek from '../../images/team/Vašek.JPG';
import nela from '../../images/team/Nela.JPG';
import danka from '../../images/team/Danka.JPG';
import vopi from '../../images/team/Vopi.JPG';
import jancas from '../../images/team/Jancas.JPG';
import hadr from '../../images/team/Hadr.JPG';
import martin from '../../images/team/Revizors.JPG';




class CoreTeam extends Component {
    render() {
        return(
            <>
            <section id="ct">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="feature_header text-center">

                                <h3 class="feature_title">Core Team</h3>
                                <h4 class="feature_sub">Here you can find all members of our core team with link to FB profile. </h4>
                                <div class="divider"></div>
                            </div>


                            </div>
                        </div>

                        <div id="owl-demo" class="owl-carousel owl-theme team-items">
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={lucka} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/pavel.linder"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Lucka </p>
                                        </div>
                                    </div>
                                    <h3>Pavel Linder</h3>
                                    <h5>Main organizer</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={tawy} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://facebook.com/Tawiik"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Tawy </p>
                                        </div>
                                    </div>
                                    <h3>Ivan Van Duy Ta</h3>
                                    <h5>Main organizer</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={jancas} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/jkrocova"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Jančas </p>
                                        </div>
                                    </div>
                                    <h3>Jana Kročová</h3>
                                    <h5>Participant responsible</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={vasek} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/profile.php?id=100013375027574"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Vašek </p>
                                        </div>
                                    </div>
                                    <h3>Václav Fišer</h3>
                                    <h5>Academic responsible</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={nela} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/nela.petrzelkova"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Nela </p>
                                        </div>
                                    </div>
                                    <h3>Nela Petrželková</h3>
                                    <h5>Social Responsible</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={hadr} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/jan.rataj.338"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Hadr </p>
                                        </div>
                                    </div>
                                    <h3>Jan Rataj</h3>
                                    <h5>Social Responsible</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={danka} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/profile.php?id=100013373465166"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Danka </p>
                                        </div>
                                    </div>
                                    <h3>Dana Duchoslavová</h3>
                                    <h5>Logistic Responsible</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={vopi} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/XvopiX"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Vopi </p>
                                        </div>
                                    </div>
                                    <h3>Tomáš Opička</h3>
                                    <h5>Logistic Responsible</h5>
                                </div>
                            </div>
                            <div class="item text-center">
                                <div class="single-member" style={{"width": "80%"}}>
                                    <div class="overlay-hover">
                                        <img src={martin} alt="" class="img-responsive"></img>
                                        <div class="overlay-effect">
                                            <ul class="social list-inline">
                                                <li><a href="https://www.facebook.com/martin.helmich.1447"><i class="fa fa-facebook"></i></a></li>
                                            </ul>
                                            <p> Hračkářs </p>
                                        </div>
                                    </div>
                                    <h3>Martin Helmich</h3>
                                    <h5>Food Responsible</h5>
                                </div>
                            </div>
                        </div>
                    </div>
            </section>
            </>
        );
    }
}

export default CoreTeam;